import type { PropsWithChildren, ReactNode } from 'react';

import { u } from '../../../styles';
import { Box } from '../../Layout';
import { Text } from '../../Text';
import * as css from './ParameterCardTitle.css';

/**
 * The title content and optional actions for a parameter card.
 *
 * Providing a `startSlot` makes the title selectable in appearance. Slots are
 * rendered at the start and end of the title respectively.
 */
export type ParameterCardTitleProps = {
    startSlot?: ReactNode;
    endSlot?: ReactNode;
    compact?: boolean;
};

/**
 * Renders a parameter card title with an optional selection control and menu.
 *
 * A title with a start slot uses the selectable heading style.
 */
export const ParameterCardTitle = ({
    startSlot,
    endSlot,
    compact = false,
    children,
}: PropsWithChildren<ParameterCardTitleProps>) => {
    const isSelectable = startSlot !== undefined;
    return (
        <Box
            className={css.header({ compact })}
            display="flex"
            alignItems="flex-start"
            columnGap={startSlot || endSlot ? u(1) : undefined}
        >
            {startSlot}

            <Text variant={isSelectable ? 'h3' : 'h2'} textAlign="left" className={css.title({ compact })}>
                {children}
            </Text>

            {endSlot ? <Box className={css.headerAction}>{endSlot}</Box> : null}
        </Box>
    );
};
